import { downloadFile, getNCFileFromVersions } from '@helpers';
import { GenerateNCFileURL } from '@interfaces/methods';
import { LinkedNCFile, NCFileSearchItem, OperationSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';

export const shareNCFile = async ({
  generateNCFileURL,
  ncFileData,
}: {
  generateNCFileURL: GenerateNCFileURL;
  ncFileData: NCFileSearchItem | null;
}) => {
  if (!ncFileData || !ncFileData?.versions) {
    return;
  }

  const ncFileContentHash = getNCFileFromVersions(ncFileData?.versions);
  const fileUrl = await generateNCFileURL({
    fullFile: true,
    ncFileContentHash,
  });

  const fileName = ncFileData.ncFileName;
  await downloadFile({ fileUrl, fileName: fileName });
};

export const getUniqueNcFilesFromJobs = (jobs: ReducerEntityWithLoadingState<OperationSearchItem[]>): LinkedNCFile[] => {
  // Handle different data structures:
  // 1. jobs.data is an array directly
  // 2. jobs.data.data is an array (nested structure from Redux)
  let jobsArray;
  
  if (Array.isArray(jobs?.data)) {
    jobsArray = jobs.data;
  } else if (Array.isArray(jobs?.data?.data)) {
    jobsArray = jobs.data.data;
  } else {
    return [];
  }
  
  const allFiles = jobsArray.flatMap((job) => job.linkedNcFiles ?? []);
  const seen = new Set<number>();
  return allFiles.reduce<LinkedNCFile[]>((acc, file) => {
    if (!seen.has(file.ncFileId)) {
      seen.add(file.ncFileId);
      acc.push(file);
    }
    return acc;
  }, []);
};
